import React, { useEffect, useRef } from 'react'
import $ from 'jquery'
import '../../../components/data-table/data-table.css'

function SummaryTable({ tableConfig }) {


    return ((tableConfig.tableColumns.length > 0) && (
        <table className='react-data-table'>
         
                <thead>
                    <tr>
                    <th></th><th></th>
                    </tr>
                </thead>
            
            <tbody>
                {/* Overview Data*/}
                {tableConfig.tableData.map((tableRow, index) => {
                    return (
                        <tr key={index}>
                            {tableConfig.tableColumnIds.map((tableCol, index) => {

                                return (
                                    <td key={1000 + index}>
                                        <div className='data-table-input-cell'>
                                            <p className='data-table-text'> {tableRow[tableCol] !== null ? (
                                                typeof tableRow[tableCol] === 'object' ? (
                                                    tableRow[tableCol]?.propertyName // Replace 'propertyName' with the actual property name you want to display.
                                                ) : typeof tableRow[tableCol] === 'number' ? (
                                                    tableRow[tableCol].toLocaleString('en-US')
                                                ) : (
                                                    tableRow[tableCol]
                                                )
                                            ) : (
                                                '' // Replace 'N/A' with any appropriate text for null values
                                            )}</p>
                                        </div>
                                    </td>
                                )
                            })}
                        </tr>
                    )
                })}

            </tbody>
        </table>
        )
    )
}




export default SummaryTable